import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const NameField = () => {
  return (
    <FormField label="Name *" htmlFor="name">
      <FormikInput id="name" name="name" />
    </FormField>
  );
};

export default NameField;
